import './landing.scss';
import { initNavbar, initDeviceMedia, initDeviceDialog, initDemo, initFooterYear, initCreatorAccent } from '@/ui';
import { initPostHog } from '@/services/posthog';

initPostHog();

function boot(): void {
  // Before the demo, so the sample creator's card paints with a readable label.
  initCreatorAccent();
  initNavbar();
  initDeviceMedia();
  initDeviceDialog();
  initDemo();
  initFooterYear();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot, { once: true });
} else {
  boot();
}
